import { render, staticRenderFns } from "./TestSignatureTemplate.vue?vue&type=template&id=394a1daa&scoped=true"
import script from "./TestSignatureTemplate.vue?vue&type=script&lang=js"
export * from "./TestSignatureTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a1daa",
  null
  
)

export default component.exports